import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MediasService } from '../../../../../services/medias.service';
import { ReelsService } from '../../../../../services/reels.service';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { takeUntil } from 'rxjs/operators';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ShowVideoComponent } from '../../media/show-video/show-video.component';

@Component({
	selector: 'app-config-medias',
	templateUrl: './config-medias.component.html',
	styleUrls: ['./config-medias.component.scss']
})
export class ConfigMediasComponent implements OnInit, OnDestroy {
	@Input() data: any = {};
	medias: any = [];
	selectedMedias: any = [];
	reel: any;
	ref: DynamicDialogRef | undefined;

	private atComponentDestroy = new Subject();

	constructor(
		private mediasService: MediasService,
		private reelsService: ReelsService,
		public modalRef: BsModalRef,
		public dialogService: DialogService
	) { }


	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
		if (this.ref) {
			this.ref.close();
		}
	}

	async ngOnInit(): Promise<void> {
		const reelResponse = await this.reelsService.show(this.data.id);
		this.reel = reelResponse.response;
		this.selectedMedias = [... this.reel.medias];
		this.selectedMedias = this.updateVigenciaStatus(this.selectedMedias);
		this.medias = await this.mediasService.getMediasByType(this.reel.type);
		this.medias = this.updateVigenciaStatus(this.medias);
	}

	updateVigenciaStatus(list): any {
		const hoy = new Date();

		return list = list.map(media => {
			const fechaVigencia = new Date(media.vigencia);
			return {
			...media,
			vigente: hoy <= fechaVigencia   // true si hoy es menor o igual a la vigencia
			};
		});
	}

	/**
	 * Send data to the server
	 */
	submit(): void {
		const selectedValues = [];
		this.selectedMedias.forEach(element => {
			selectedValues.push(element.id);
		});

		this.reelsService.saveMedias({ medias: selectedValues }, this.data.id)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				data => {
					this.modalRef.hide();
				}
			);
	}

	/**
	 * Update array with the right sorting
	 * @param $event
	 */
	async moveToTarget($event) {
		for (const element of $event.items) {
			const index = this.medias.findIndex(media => media.id === element.id);
			if (index < 0) {
				this.medias.push({ ...element });
			}
		}

		this.medias.sort((a, b) => parseFloat(a.id) - parseFloat(b.id));
	}

	removeFromTarget($event) {
		for (const element of $event.items){
			this.medias.pop();
		}
	}

	/**
	 * Open a modal window with the video
	 * @param media
	 */
	openVideo(media): void {
		this.ref = this.dialogService.open(ShowVideoComponent, {
			header: 'Ver Video',
			width: '70%',
			baseZIndex: 10000,
			data: media,
			closeOnEscape: false
		});
	}

}
